var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.todos),function(todo){return _c('div',{key:todo},[_c('TodoItem',{attrs:{"todo":todo},on:{"del-todo":function($event){return _vm.$emit('del-todo', todo.id)}}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }